'use client';

import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePost } from '@/queries/posts/usePost';
import { PostModal } from '../PostModal/PostModal';

export const PostRoute = observer(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const { data: postData } = usePost(searchParams.get('post') as string);

  if (!postData?.data) {
    return null;
  }

  const close = () => {
    const params = new URLSearchParams(location.search);
    params.delete('post');
    const newSearch = params.size > 0 ? `?${params.toString()}` : '';
    navigate(`${location.pathname}${newSearch}`);
  };

  return <PostModal post={postData.data} onClose={close} />;
});
